import { STREET_DIRECTIONS, STREET_TYPES } from '@ratehub/documents/common/stable';

import {
    CoverageAmountValues,
    DisabilityCoverageAmountHighestValue,
} from '../src/definitions/CurrentDocument';


export default {
    applicant: {
        homeAddress: {
            streetNumber: '100',
            streetName: 'King',
            streetType: STREET_TYPES.STREET,
            streetDirection: STREET_DIRECTIONS.WEST,
            city: 'Toronto',
            province: 'ON',
            postalCode: 'M5X1A9',
        },
        hasConsumedTobacco: true,
        isCanadianCitizen: true,
        grossAnnualIncome: 100_000,
        occupation: 'Software Developer',
    },
    wantsBundledQuote: true,
    coverageAmount: CoverageAmountValues.UNDER_1M,
    isJointPolicy: true,
    disabilityCoverageAmount: DisabilityCoverageAmountHighestValue,
    companyName: 'Test Company',
    businessAddress: {
        streetNumber: '100',
        streetName: 'King',
        streetType: STREET_TYPES.STREET,
        streetDirection: STREET_DIRECTIONS.WEST,
        city: 'Toronto',
        province: 'ON',
        postalCode: 'M5X1A9',
    },
    numberOfEmployees: 100,
};